var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgErrorUnplugged(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 180,
    viewBox: "0 0 180 180",
    width: 180,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#9ea7a9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m177.906 156.976-20.93 20.93-18.837-14.652 25.116-25.113z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m81.627 64.8849 8.3731-8.3732 20.9299 20.9296c2.312 2.3122 2.312 6.0609 0 8.3731-2.313 2.3123-6.061 2.3123-8.373 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.5117 90.0001 8.37-8.37 20.9327 20.9299c2.3123 2.309 2.3123 6.057 0 8.37-2.3122 2.312-6.0609 2.312-8.3731 0z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0 8.37073 8.37316-8.36999758 8.37314 8.36999758-8.37314 8.37317z",
    fill: "#717679"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m2.09277 23.0241 20.92993-20.92962 18.8378 14.65132-25.1164 25.1132z",
    fill: "#9ea7a9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m41.8609 87.9058 46.0459-46.0459c2.3122-2.3122 6.0609-2.3122 8.3731 0s2.3122 6.0609 0 8.3732l-46.0459 46.0459c-2.3122 2.3122-6.0609 2.3122-8.3731 0-2.3119-2.3123-2.3119-6.0613 0-8.3732z",
    fill: "#4e5356"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m18.2398 40.366 22.1245-22.1277c4.385-4.3823 11.4082-4.6428 16.1037-.5928l31.4377 24.2132-46.0455 46.0459-24.2163-31.4378c-4.05-4.6958-3.7892-11.7186.5959-16.1008z",
    fill: "#717679"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m41.3194 46.5884 5.2664-5.2664c5.4809-5.4837 14.3691-5.4837 19.8496 0l11.0078 11.0049-25.1192 25.1132-11.0049-11.0018c-5.4802-5.4844-5.4802-14.3694.0003-19.8499z",
    fill: "#9ea7a9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m180 171.629-8.373 8.37-8.373-8.37 8.373-8.373z",
    fill: "#717679"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m147.907 173.335c-.795 0-1.589-.304-2.194-.909-1.214-1.213-1.214-3.175 0-4.388l6.976-6.976c1.214-1.214 3.175-1.214 4.389 0 1.213 1.213 1.213 3.175 0 4.388l-6.977 6.976c-.605.605-1.399.909-2.194.909z",
    fill: "#717679"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m163.257 157.988c-.795 0-1.589-.304-2.194-.909-1.214-1.214-1.214-3.175 0-4.388l6.976-6.977c1.214-1.213 3.175-1.213 4.388 0 1.214 1.214 1.214 3.175 0 4.388l-6.976 6.977c-.605.605-1.4.909-2.194.909z",
    fill: "#717679"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m138.14 92.0938-46.0463 46.0462c-2.3123 2.312-6.061 2.312-8.3732 0-2.3122-2.313-2.3122-6.061 0-8.373l46.0455-46.046c2.313-2.3122 6.061-2.3122 8.374 0 2.311 2.3119 2.311 6.0609 0 8.3728z",
    fill: "#4e5356"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m161.761 139.634-22.125 22.128c-4.385 4.382-11.408 4.642-16.103.592l-31.4383-24.213 46.0453-46.0458 24.217 31.4378c4.05 4.696 3.789 11.719-.596 16.101z",
    fill: "#717679"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m138.742 133.351-5.388 5.388c-5.45 5.449-14.282 5.449-19.729 0l-11.066-11.064 25.116-25.116 11.067 11.067c5.446 5.446 5.446 14.279 0 19.725z",
    fill: "#9ea7a9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m25.118 19.848c-.7946 0-1.5891-.3041-2.1941-.9091-1.2136-1.2136-1.2136-3.175 0-4.3882l6.9764-6.97644c1.2136-1.2136 3.1749-1.2136 4.3882 0 1.2132 1.21359 1.2136 3.17494 0 4.38824l-6.9764 6.9764c-.6051.605-1.3996.9091-2.1941.9091z",
    fill: "#717679"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m9.76836 35.1959c-.79453 0-1.58906-.3041-2.1941-.9091-1.2136-1.2136-1.2136-3.175 0-4.3882l6.97644-6.9764c1.2136-1.2136 3.1749-1.2136 4.3882 0 1.2136 1.2136 1.2136 3.1749 0 4.3882l-6.9764 6.9764c-.6051.605-1.3996.9091-2.19414.9091z",
    fill: "#717679"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorUnplugged);
export default __webpack_public_path__ + "static/media/error-unplugged.9ee1f6c37208f7475cce7bbec8c5895c.svg";
export { ForwardRef as ReactComponent };